// ============================================================
// DATOS MOCK - POS Compacto para Colombia
// Reemplazar por llamadas al backend .NET Core cuando esté listo
// ============================================================

// -------- USUARIOS Y ROLES --------
export const mockRoles = [
  {
    id: 1,
    nombre: 'Superadmin',
    descripcion: 'Acceso total. Configura el sistema, negocios, usuarios y permisos.',
    permisos: ['*'],
  },
  {
    id: 2,
    nombre: 'Admin',
    descripcion: 'Administra el negocio: inventario, ventas, reportes y usuarios de su negocio.',
    permisos: [
      'dashboard.view', 'pos.use', 'inventario.gestionar', 'clientes.gestionar',
      'ventas.ver', 'reportes.ver', 'caja.gestionar', 'usuarios.gestionar',
      'ordenes.recibir',
    ],
  },
  {
    id: 3,
    nombre: 'Cajero',
    descripcion: 'Opera la caja, factura y cierra el turno.',
    permisos: ['pos.use', 'caja.gestionar', 'clientes.ver', 'inventario.ver', 'ordenes.recibir'],
  },
  {
    id: 4,
    nombre: 'Vendedor',
    descripcion: 'Registra ventas y consulta inventario.',
    permisos: ['pos.use', 'inventario.ver', 'clientes.ver'],
  },
  {
    id: 5,
    nombre: 'Domiciliario',
    descripcion: 'Gestiona entregas a domicilio.',
    permisos: ['domicilios.gestionar', 'clientes.ver'],
  },
];

export const mockUsuarios = [
  { id: 1, nombre: 'Carlos Pérez', usuario: 'admin', email: 'admin@papeleria.co', rolId: 1, activo: true, telefono: '3001234567', fechaCreacion: '2024-01-10' },
  { id: 2, nombre: 'María Rodríguez', usuario: 'mrodriguez', email: 'maria@papeleria.co', rolId: 2, activo: true, telefono: '3009876543', fechaCreacion: '2024-02-15' },
  { id: 3, nombre: 'Juan Gómez', usuario: 'jgomez', email: 'juan@papeleria.co', rolId: 3, activo: true, telefono: '3155551122', fechaCreacion: '2024-03-01' },
  { id: 4, nombre: 'Ana Torres', usuario: 'atorres', email: 'ana@papeleria.co', rolId: 4, activo: true, telefono: '3208887766', fechaCreacion: '2024-04-20' },
  { id: 5, nombre: 'Pedro Ramírez', usuario: 'pramirez', email: 'pedro@papeleria.co', rolId: 5, activo: false, telefono: '3164443322', fechaCreacion: '2024-05-05' },
];

// -------- NEGOCIOS (multi-negocio) --------
export const mockNegocios = [
  {
    id: 1,
    nombre: 'Papelería La Esquina',
    nit: '900123456-7',
    direccion: 'Calle 45 # 12-34, Bucaramanga',
    telefono: '6076123456',
    email: 'contacto@papelerialaesquina.co',
    logo: null,
    tipo: 'Papelería',
    regimen: 'Común',
    facturacionElectronica: true,
    resolucionDian: '18764000001234',
    prefijoFactura: 'FE',
    consecutivoActual: 1245,
    // Modo de operación de cajas:
    // 'caja_unica'         → una sola caja física, una sesión abierta a la vez
    // 'multi_caja'         → varias cajas físicas, N sesiones en paralelo (una por caja)
    // 'vendedor_a_caja'    → vendedores arman ventas en piso, un cajero central cobra
    modoOperacion: 'vendedor_a_caja',
  },
];

// -------- CAJAS FÍSICAS (catálogo) --------
export const mockCajas = [
  { id: 1, nombre: 'Caja Principal',      ubicacion: 'Mostrador frente',    ipImpresora: '192.168.1.50', activa: true,  fechaCreacion: '2024-01-15' },
  { id: 2, nombre: 'Caja Escolar',        ubicacion: 'Zona escolar 2do piso', ipImpresora: '192.168.1.51', activa: true,  fechaCreacion: '2024-02-10' },
  { id: 3, nombre: 'Caja Auxiliar',       ubicacion: 'Bodega',              ipImpresora: '',             activa: false, fechaCreacion: '2024-05-01' },
];

// -------- CATEGORÍAS Y PRODUCTOS --------
export const mockCategorias = [
  { id: 1, nombre: 'Cuadernos', color: '#1565c0' },
  { id: 2, nombre: 'Escritura', color: '#2e7d32' },
  { id: 3, nombre: 'Oficina', color: '#ef6c00' },
  { id: 4, nombre: 'Arte y manualidades', color: '#c2185b' },
  { id: 5, nombre: 'Tecnología', color: '#5e35b1' },
  { id: 6, nombre: 'Golosinas', color: '#d84315' },
  { id: 7, nombre: 'Impresión', color: '#00838f' },
];

export const mockProductos = [
  { id: 1,  codigoBarras: '7701234500001', nombre: 'Cuaderno cosido 100 hojas Norma', categoriaId: 1, costo: 4500,  precioVenta: 8500,  stock: 45, stockMinimo: 10, iva: 19, unidad: 'unidad', imagen: null },
  { id: 2,  codigoBarras: '7701234500002', nombre: 'Cuaderno argollado universitario', categoriaId: 1, costo: 6800,  precioVenta: 12500, stock: 32, stockMinimo: 8,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 3,  codigoBarras: '7701234500003', nombre: 'Lápiz Mirado #2 (unidad)',       categoriaId: 2, costo: 400,   precioVenta: 900,   stock: 250,stockMinimo: 50, iva: 19, unidad: 'unidad', imagen: null },
  { id: 4,  codigoBarras: '7701234500004', nombre: 'Esfero Bic azul',                categoriaId: 2, costo: 500,   precioVenta: 1200,  stock: 180,stockMinimo: 40, iva: 19, unidad: 'unidad', imagen: null },
  { id: 5,  codigoBarras: '7701234500005', nombre: 'Marcador Sharpie negro',         categoriaId: 2, costo: 3200,  precioVenta: 5800,  stock: 40, stockMinimo: 12, iva: 19, unidad: 'unidad', imagen: null },
  { id: 6,  codigoBarras: '7701234500006', nombre: 'Grapadora Rank estándar',        categoriaId: 3, costo: 12000, precioVenta: 22000, stock: 8,  stockMinimo: 3,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 7,  codigoBarras: '7701234500007', nombre: 'Cinta transparente 18mm',        categoriaId: 3, costo: 1400,  precioVenta: 2800,  stock: 65, stockMinimo: 15, iva: 19, unidad: 'unidad', imagen: null },
  { id: 8,  codigoBarras: '7701234500008', nombre: 'Perforadora 2 huecos',           categoriaId: 3, costo: 14000, precioVenta: 24500, stock: 5,  stockMinimo: 3,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 9,  codigoBarras: '7701234500009', nombre: 'Plastilina Play-Doh 4 colores',  categoriaId: 4, costo: 9500,  precioVenta: 15900, stock: 22, stockMinimo: 6,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 10, codigoBarras: '7701234500010', nombre: 'Colores Prismacolor x 12',       categoriaId: 4, costo: 18000, precioVenta: 29900, stock: 18, stockMinimo: 5,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 11, codigoBarras: '7701234500011', nombre: 'Tijeras escolares punta roma',   categoriaId: 4, costo: 2500,  precioVenta: 4900,  stock: 30, stockMinimo: 10, iva: 19, unidad: 'unidad', imagen: null },
  { id: 12, codigoBarras: '7701234500012', nombre: 'USB Kingston 32GB',              categoriaId: 5, costo: 22000, precioVenta: 38000, stock: 12, stockMinimo: 4,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 13, codigoBarras: '7701234500013', nombre: 'Audífonos genéricos',            categoriaId: 5, costo: 8000,  precioVenta: 15000, stock: 15, stockMinimo: 5,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 14, codigoBarras: '7701234500014', nombre: 'Chocolatina Jet',                categoriaId: 6, costo: 900,   precioVenta: 1500,  stock: 120,stockMinimo: 30, iva: 5,  unidad: 'unidad', imagen: null },
  { id: 15, codigoBarras: '7701234500015', nombre: 'Bon Bon Bum surtido',            categoriaId: 6, costo: 250,   precioVenta: 500,   stock: 300,stockMinimo: 80, iva: 5,  unidad: 'unidad', imagen: null },
  { id: 16, codigoBarras: '7701234500016', nombre: 'Fotocopia B/N',                  categoriaId: 7, costo: 50,    precioVenta: 200,   stock: 9999,stockMinimo: 0, iva: 0,  unidad: 'servicio', imagen: null },
  { id: 17, codigoBarras: '7701234500017', nombre: 'Impresión color carta',          categoriaId: 7, costo: 300,   precioVenta: 1000,  stock: 9999,stockMinimo: 0, iva: 0,  unidad: 'servicio', imagen: null },
  { id: 18, codigoBarras: '7701234500018', nombre: 'Resma papel carta 75g',          categoriaId: 3, costo: 14500, precioVenta: 22900, stock: 20, stockMinimo: 5,  iva: 19, unidad: 'unidad', imagen: null },
  { id: 19, codigoBarras: '7701234500019', nombre: 'Sobre manila oficio',            categoriaId: 3, costo: 350,   precioVenta: 800,   stock: 150,stockMinimo: 40, iva: 19, unidad: 'unidad', imagen: null },
  { id: 20, codigoBarras: '7701234500020', nombre: 'Corrector líquido',              categoriaId: 2, costo: 2200,  precioVenta: 4500,  stock: 4,  stockMinimo: 8,  iva: 19, unidad: 'unidad', imagen: null },
];

// -------- CLIENTES --------
export const mockClientes = [
  { id: 1, tipoDoc: 'CC', documento: '1098765432', nombre: 'Consumidor Final',    email: '',                        telefono: '',            direccion: '',                          totalCompras: 0,        frecuente: false },
  { id: 2, tipoDoc: 'CC', documento: '63123456',   nombre: 'Laura Jiménez',       email: 'laura.j@gmail.com',       telefono: '3001112233', direccion: 'Cra 27 # 34-56, B/manga',   totalCompras: 245000,   frecuente: true  },
  { id: 3, tipoDoc: 'NIT',documento: '900456789-1',nombre: 'Colegio San Pedro',   email: 'compras@sanpedro.edu.co', telefono: '6076445566', direccion: 'Av. González Valencia',      totalCompras: 3450000,  frecuente: true  },
  { id: 4, tipoDoc: 'CC', documento: '91234567',   nombre: 'Andrés Vargas',       email: 'andres.v@hotmail.com',    telefono: '3155556677', direccion: 'Barrio Cabecera',           totalCompras: 89000,    frecuente: false },
  { id: 5, tipoDoc: 'NIT',documento: '830111222-3',nombre: 'Constructora ABC',    email: 'admon@abc.co',            telefono: '6076998877', direccion: 'Zona industrial',           totalCompras: 1250000,  frecuente: true  },
];

// -------- VENTAS (histórico) --------
const hoy = new Date();
const diasAtras = (n) => {
  const d = new Date(hoy);
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

// Ventas de ejemplo — VACIADO (deprecado).
// Los datos reales vienen del backend via apiVentas.listar().
export const mockVentas = [];

// Serie diaria de últimos 30 días para dashboard
// Serie diaria de ventas — VACIADA (deprecada).
// Los datos reales vienen del backend via apiReportes.serieDiaria().
// Se mantiene el export para no romper imports huérfanos, pero devuelve
// array vacío: cualquier componente que aún lo importe mostrará "sin
// datos" en vez de valores ficticios de $170k-$340k que confunden.
export const mockSerieVentasDiaria = [];

// Top productos vendidos — VACIADO (deprecada).
// Los datos reales vienen del backend via apiReportes.productosMasVendidos().
export const mockTopProductos = [];

// -------- CAJA --------
// Sesiones abiertas en este momento (una por caja física, una por cajero).
// En modo caja_unica solo habría una. En multi_caja pueden ser varias en paralelo.
export const mockSesionesActivas = [
  {
    id: 45,
    cajaId: 1,
    cajaNombre: 'Caja Principal',
    abierta: true,
    fechaApertura: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(), // hace 3h
    cajeroId: 3,
    cajeroNombre: 'Juan Gómez',
    baseInicial: 100000,
    ventasEfectivo: 245000,
    ventasTarjeta: 71400,
    ventasTransferencia: 106624,
    ingresos: 0,
    egresos: 15000,
    totalEsperadoEfectivo: 330000, // base + ventasEfectivo - egresos
  },
  {
    id: 46,
    cajaId: 2,
    cajaNombre: 'Caja Escolar',
    abierta: true,
    fechaApertura: new Date(Date.now() - 1.5 * 60 * 60 * 1000).toISOString(), // hace 1h 30m
    cajeroId: 4,
    cajeroNombre: 'Ana Torres',
    baseInicial: 80000,
    ventasEfectivo: 132500,
    ventasTarjeta: 48900,
    ventasTransferencia: 62300,
    ingresos: 0,
    egresos: 0,
    totalEsperadoEfectivo: 212500,
  },
];

// Alias para retro-compat: la primera sesión activa (la de Juan Gómez).
// El TopBar y otros consumidores viejos siguen funcionando; los nuevos usan mockSesionesActivas.
export const mockCajaActual = mockSesionesActivas[0];

// -------- ÓRDENES PENDIENTES DE COBRO --------
// Solo aplica en modo 'vendedor_a_caja': los vendedores arman ventas en piso
// y las envían al cajero para que este cobre y facture.
// Estados: 'pendiente' (esperando cajero) | 'en_cobro' (cajero la está procesando)
export const mockOrdenesPendientes = [
  {
    id: 101,
    vendedorId: 4,
    vendedorNombre: 'Ana Torres',
    clienteId: 2,
    clienteNombre: 'Laura Jiménez',
    items: [
      { productoId: 1, nombre: 'Cuaderno cosido 100 hojas Norma', cantidad: 3, precioUnitario: 8500,  iva: 19 },
      { productoId: 3, nombre: 'Lápiz Mirado #2 (unidad)',        cantidad: 6, precioUnitario: 900,   iva: 19 },
      { productoId: 6, nombre: 'Grapadora Rank estándar',         cantidad: 1, precioUnitario: 22000, iva: 19 },
    ],
    subtotal: 52900,
    ivaTotal: 10051,
    total: 62951,
    fechaCreacion: new Date(Date.now() - 4 * 60 * 1000).toISOString(),  // hace 4 min
    notas: 'Cliente pide factura electrónica a su nombre',
    estado: 'pendiente',
  },
  {
    id: 102,
    vendedorId: 4,
    vendedorNombre: 'Ana Torres',
    clienteId: 1,
    clienteNombre: 'Consumidor Final',
    items: [
      { productoId: 7, nombre: 'Cinta transparente 18mm', cantidad: 2, precioUnitario: 2800, iva: 19 },
      { productoId: 4, nombre: 'Esfero Bic azul',         cantidad: 4, precioUnitario: 1200, iva: 19 },
    ],
    subtotal: 10400,
    ivaTotal: 1976,
    total: 12376,
    fechaCreacion: new Date(Date.now() - 12 * 60 * 1000).toISOString(), // hace 12 min
    notas: '',
    estado: 'pendiente',
  },
  {
    id: 103,
    vendedorId: 4,
    vendedorNombre: 'Ana Torres',
    clienteId: 3,
    clienteNombre: 'Colegio San Pedro',
    items: [
      { productoId: 1,  nombre: 'Cuaderno cosido 100 hojas Norma', cantidad: 50, precioUnitario: 8500, iva: 19 },
      { productoId: 3,  nombre: 'Lápiz Mirado #2 (unidad)',        cantidad: 100, precioUnitario: 900, iva: 19 },
    ],
    subtotal: 515000,
    ivaTotal: 97850,
    total: 612850,
    fechaCreacion: new Date(Date.now() - 25 * 60 * 1000).toISOString(), // hace 25 min
    notas: 'Pedido escolar. Verificar NIT antes de facturar.',
    estado: 'pendiente',
  },
];

export const mockHistorialCaja = [
  { id: 44, cajaId: 1, cajaNombre: 'Caja Principal', fechaApertura: diasAtras(1), fechaCierre: diasAtras(1), cajeroNombre: 'Juan Gómez',  baseInicial: 100000, totalVendido: 485000, diferencia: 0,     estado: 'Cerrada' },
  { id: 43, cajaId: 1, cajaNombre: 'Caja Principal', fechaApertura: diasAtras(2), fechaCierre: diasAtras(2), cajeroNombre: 'Ana Torres',  baseInicial: 100000, totalVendido: 512000, diferencia: -3000, estado: 'Cerrada' },
  { id: 42, cajaId: 2, cajaNombre: 'Caja Escolar',   fechaApertura: diasAtras(2), fechaCierre: diasAtras(2), cajeroNombre: 'Ana Torres',  baseInicial: 80000,  totalVendido: 287000, diferencia: 1500,  estado: 'Cerrada' },
  { id: 41, cajaId: 1, cajaNombre: 'Caja Principal', fechaApertura: diasAtras(3), fechaCierre: diasAtras(3), cajeroNombre: 'Juan Gómez',  baseInicial: 100000, totalVendido: 398000, diferencia: 500,   estado: 'Cerrada' },
];

// -------- MÉTODOS DE PAGO --------
export const mockMetodosPago = [
  { id: 'efectivo',     nombre: 'Efectivo',      icono: 'Payments' },
  { id: 'tarjeta',      nombre: 'Tarjeta',       icono: 'CreditCard' },
  { id: 'transferencia',nombre: 'Transferencia', icono: 'AccountBalance' },
  { id: 'nequi',        nombre: 'Nequi',         icono: 'PhoneAndroid' },
  { id: 'daviplata',    nombre: 'Daviplata',     icono: 'PhoneAndroid' },
];

// -------- HELPERS --------
export const formatCOP = (v) =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(v || 0);

export const formatFecha = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('es-CO', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
};

export const formatFechaHora = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('es-CO', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

export const getRolNombre = (rolId) => mockRoles.find((r) => r.id === rolId)?.nombre || 'Desconocido';
export const getCategoriaNombre = (id) => mockCategorias.find((c) => c.id === id)?.nombre || '';
export const getCategoriaColor = (id) => mockCategorias.find((c) => c.id === id)?.color || '#999';
export const getClienteNombre = (id) => mockClientes.find((c) => c.id === id)?.nombre || 'Consumidor Final';
export const getCajaNombre = (id) => mockCajas.find((c) => c.id === id)?.nombre || 'Sin caja';
